module.exports = __webpack_public_path__ + "img/elibro.e7ea6d07.png";